<template>
  <div>
    <div class="menu">
      <div class="actived" style="min-width: 70px;">练习题</div>
      <div style="min-width: 70px;">
        <router-link :to="'/examinationBank/errorQuestion?id=' +
          $route.query.id +
          '&name=' +
          $route.query.name
          ">错题本</router-link>
      </div>
      <div style="width: 100%; text-align: right">
        <Button size="small" @click="$router.replace('/examinationBank/questionBank')">返回</Button>
      </div>
    </div>
    <!-- menu菜单操作有bug 先用div -->
    <!-- <Menu mode="horizontal" :active-name="showin" @on-select="changMenuItem">
      <MenuItem name="a" style="margin: 0 20px">练习题</MenuItem>
      <MenuItem
        name="b"
        :to="
          '/examinationBank/errorQuestion?id=' +
          $route.query.id +
          '&name=' +
          $route.query.name
        "
        >错题本</MenuItem
      >
    </Menu> -->
    <Row class="questionbank">
      <Col span="5" class="questionbank-left">
      <p class="left-p">选择题型</p>
      <div class="left-div">
        <a v-for="(item, index) in questiontypeArr" :key="index" @click="getquestioncount(item, index)" :style="{
          color: show == index ? '#fff' : '#333',
          backgroundColor: show == index ? '#2d8cf0' : '#fff',
        }">{{ item.question_type.name }}</a>
      </div>
      </Col>
      <Col span="19" class="questionbank-right">
      <p class="right-p">
        共{{ questionsObj.total_count }}道，已练{{
          questionsObj.finish_count
        }}道。完成率{{ questionsObj.rate * 100 }}%
      </p>
      <div class="right-div">
        <p class="right-div-p">ID：{{ qesid }}</p>
        <Row class="e-list" v-if="questions.question && questions.question.question_type">
          <Col class="e-list-c" v-if="questions.question.question_type.basic_ques_types == 5"><!-- 阅读理解选择题 -->
          <p class="e-list-c-b" v-if="questions.question.formatData.stem_src_txt"
            v-html="questions.question.formatData.stem_src_txt"></p>
          <div class="e-list-c-c" v-if="
            questions.question.question_type.batch == 2 &&
            questions.question.formatData.sub_headings
          " v-html="questions.question.formatData.sub_headings[0].sub_heading
            "></div>
          <div class="e-list-c-a" v-if="
            questions.question.question_type.batch == 2 &&
            questions.question.formatData.sub_headings
          ">
            <RadioGroup v-model="questions.question.ques_sub_headings[0].answe" vertical>
              <Radio :label="option.option_k" v-for="(option, i) in questions.question.formatData
                .sub_headings[0].options" :key="i" :id="option.option_k">
                <span v-html="String.fromCharCode(65 + i) + '.' + option.option"></span>
              </Radio>
            </RadioGroup>
          </div>
          <div v-show="questions.question.question_type.batch == 1 &&
            questions.question.formatData.sub_headings
            " v-for="(see, se) in questions.question.formatData.sub_headings" :key="se">
            <div class="dis" v-html="se + 1 + '.' + see.sub_heading"></div>
            <div class="e-list-c-a">
              <RadioGroup v-model="questions.question.ques_sub_headings[se].answe" vertical>
                <Radio :label="option.option_k" v-for="(option, i) in see.options" :key="i" :id="option.option_k">
                  <span v-html="String.fromCharCode(65 + i) + '.' + option.option
                    "></span>
                </Radio>
              </RadioGroup>
            </div>
          </div>
          </Col>
          <!-- 填空题 -->
          <Col class="e-list-c" v-else-if="questions.question.question_type.basic_ques_types == 2">
          <div class="e-list-c-c">
            <p v-html="set_input_2(questions.question.formatData.stem)"></p>
          </div>
          <div class="e-list-c-c daan">
            <Input v-model="questions.question.ques_stem[0].answe" type="textarea" />
          </div>
          </Col>
          <!-- n选n选择题 -->
          <Col class="e-list-c" v-else-if="questions.question.question_type.basic_ques_types == 7">
          <div v-if="
            questions.question.question_type.batch == 2 &&
            questions.question.formatData.stem
          " v-html="questions.question.formatData.stem"></div>
          <div class="e-list-c-a" v-if="
            questions.question.question_type.batch == 2 &&
            questions.question.formatData.options
          ">
            <!-- <RadioGroup
                    v-model="questions.question.ques_stem[0].answe"
                    vertical
                  > -->
            <p :label="option.option_k" v-for="(option, i) in questions.question.formatData.options" :key="i"
              :id="option.option_k">
              <span v-html="String.fromCharCode(65 + i) + '.' + option.option"></span>
            </p>
            <!-- </RadioGroup> -->
          </div>
          </Col>
          <!-- 听写填空 -->
          <Col class="e-list-c" v-else-if="questions.question.question_type.basic_ques_types == 4">
          <audio style="width: 180px; height: 30px"
            v-if="questions.question.formatData && questions.question.formatData.stem_src_audio" ref="audio00" controls
            :src="questions.question.formatData.stem_src_audio"></audio>
          <div v-if="
            questions.question.ques_stem &&
            questions.question.ques_stem[0]
          " v-html="questions.question.ques_stem[0].stem_src_txt"></div>
          <div class="e-list-c-c" v-if="questions.question.ques_sub_headings[0]" v-html="regReplcae(
            questions.question.ques_sub_headings[0].sub_heading
          )
            "></div>
          </Col>
          <!-- 完形填空 -->
          <Col class="e-list-c" v-else-if="
            questions.question.question_type.basic_ques_types == 10
          ">
          <div class="e-list-c-c" v-if="questions.question.formatData.stem_src_txt"
            v-html="questions.question.formatData.stem_src_txt"></div>
          <div v-show="questions.question.formatData.sub_headings"
            v-for="(setm, i) in questions.question.formatData.sub_headings" :key="i">
            <div class="e-list-c-a" v-if="setm.options">
              <RadioGroup v-model="questions.question.ques_sub_headings[i].answe" vertical>
                {{ i + 1 }}.
                <Radio :label="option.option_k" v-for="(option, i) in setm.options" :key="i" :id="option.option_k">
                  <span v-html="String.fromCharCode(65 + i) + '.' + option.option
                    "></span>
                </Radio>
              </RadioGroup>
            </div>
          </div>
          </Col>
          <!-- 基础选择题 -->
          <Col class="e-list-c" v-else-if="questions.question.question_type.basic_ques_types == 1">
          <div class="e-list-c-c" v-if="
            questions.question.question_type.batch == 2 &&
            questions.question.formatData.sub_heading
          " v-html="questions.question.formatData.sub_heading"></div>
          <div class="e-list-c-a" v-if="
            questions.question.question_type.batch == 2 &&
            questions.question.formatData.options
          ">
            <RadioGroup v-model="questions.question.ques_sub_headings[0].answe" vertical>
              <Radio :label="option.option_k" v-for="(option, i) in questions.question.formatData.options" :key="i"
                :id="option.option_k">
                <span v-html="String.fromCharCode(65 + i) + '.' + option.option"></span>
              </Radio>
            </RadioGroup>
          </div>
          <div v-show="questions.question.question_type.batch == 1 &&
            questions.question.formatData.sub_headings
            " v-for="(setm, i) in questions.question.formatData.sub_headings" :key="i">
            <div class="e-list-c-c dis" v-html="i + 1 + '.' + setm.sub_heading"></div>
            <div class="e-list-c-a" v-if="setm.options">
              <!-- <p
                      v-for="(option, i) in setm.options"
                      :key="i"
                      v-html="String.fromCharCode(65 + i) + '.' + option.option"
                      :style="{
                        color: setm.answer[0].answer == i ? '#e76f74' : '',
                      }"
                    ></p> -->

              <RadioGroup v-model="questions.question.ques_sub_headings[i].answe" vertical>
                <Radio :label="option.option_k" v-for="(option, i) in setm.options" :key="i" :id="option.option_k">
                  <span v-html="option.option"></span>
                </Radio>
              </RadioGroup>
            </div>
          </div>
          </Col>

          <!-- 多选题 -->
          <Col class="e-list-c" v-else-if="questions.question.question_type.basic_ques_types == 12">

          <div class="e-list-c-c" v-if="
            questions.question.question_type.batch == 2 &&
            questions.question.formatData.sub_heading
          " v-html="questions.question.formatData.sub_heading"></div>

          <div class="e-list-c-a" v-if="
            questions.question.question_type.batch == 2 &&
            questions.question.formatData.options
          ">


            <CheckboxGroup class="duoxuan" v-model="questions.question.ques_sub_headings[0].answe" vertical>


              <Checkbox :label="option.option_k" v-for="(option, i) in questions.question.formatData.options" :key="i"
                :id="option.option_k">
                <span class="text" v-html="String.fromCharCode(65 + i) + '.' + option.option"></span>
              </Checkbox>


            </CheckboxGroup>

          </div>

          </Col>

          <!-- 听力选择题 -->
          <Col class="e-list-c" v-else-if="questions.question.question_type.basic_ques_types == 3">
          <div v-if="questions.question.question_type.batch == 2">
            <div class="e-list-c-b" style="display: flex; padding-bottom: 4px">
              <audio style="width: 180px; height: 30px" v-if="questions.question.formatData.stem_src_audio"
                :ref="'audio0'" controls :src="questions.question.formatData.stem_src_audio"></audio>
              <span style="margin-left: 10px" v-if="questions.question.formatData.stem_src_txt"
                v-html="questions.question.formatData.stem_src_txt"></span>
            </div>
            <div class="e-list-c-c" v-if="questions.question.formatData.sub_headings" v-html="questions.question.formatData.sub_headings[0].sub_heading
              "></div>
            <div class="e-list-c-a" v-if="questions.question.formatData.sub_headings[0]">
              <RadioGroup v-model="questions.question.ques_sub_headings[0].answe" vertical>
                <Radio :label="option.option_k" v-for="(option, i) in questions.question.formatData
                  .sub_headings[0].options" :key="i" :id="option.option_k">
                  <span v-html="String.fromCharCode(65 + i) + '.' + option.option
                    "></span>
                </Radio>
              </RadioGroup>
            </div>
          </div>
          <div v-show="questions.question.question_type.batch == 1 &&
            questions.question.formatData.sub_headings
            ">
            <div class="e-list-c-b" style="display: flex; padding-bottom: 4px">
              <audio style="width: 180px; height: 34px" ref="audioa111" controls
                v-if="questions.question.ques_stem[0].stem_src_audio"
                :src="questions.question.ques_stem[0].stem_src_audio"></audio>
            </div>
            <div v-for="(stem, i) in questions.question.formatData.sub_headings" :key="i">
              <div class="e-list-c-c dis" v-html="i + 1 + '.' + stem.sub_heading"></div>
              <audio v-if="stem.sub_src_audio" style="width: 180px; height: 34px" :ref="'audioa' + i" controls
                :src="stem.sub_src_audio"></audio>
              <div class="e-list-c-a">
                <RadioGroup v-model="questions.question.ques_sub_headings[i].answe" vertical>
                  <Radio :label="option.option_k" v-for="(option, i) in stem.options" :key="i" :id="option.option_k">
                    <span v-html="String.fromCharCode(65 + i) + '.' + option.option
                      "></span>
                  </Radio>
                </RadioGroup>
              </div>
            </div>
          </div>

          </Col>
          <Col class="e-list-c" v-else-if="
            questions.question.question_type.basic_ques_types == 11
          "><!-- 写作题 -->
          <!-- <p class="e-list-c-b">作文关键词：<span v-html="questions.question.formatData.stem"></span></p> -->
          <p class="e-list-c-b">
            字数建议：下限：
            <span v-html="questions.question.formatData.limit_l"></span>上限：<span
              v-html="questions.question.formatData.limit_r"></span>
          </p>
          <div class="e-list-c-x">
            <p v-html="questions.question.formatData.stem"></p>
          </div>
          <div class="e-list-c-c daan">
            <Input v-model="questions.question.ques_stem[0].answe" type="textarea" />
          </div>
          </Col>
          <Col class="e-list-c" v-else-if="questions.question.question_type.basic_ques_types == 6"><!-- 长篇阅读匹配 -->
          <div v-if="
            questions.question.ques_stem &&
            questions.question.ques_stem[0]
          " v-html="questions.question.ques_stem[0].stem_src_txt"></div>
          <div v-show="questions.question.formatData.sub_headings"
            v-for="(setm, i) in questions.question.formatData.sub_headings" :key="i">
            <div class="e-list-c-c dis" v-html="regReplcae(i + 1 + '.' + setm.sub_heading)"></div>
            <!-- <div class="e-list-c-x daan">
                  <p>答案：</p>
                  <Input
                    v-model="questions.question.ques_sub_headings[i].answe"
                    type="text"
                  />
                </div> -->
            <!-- <p v-if="setm.answer">答案：{{ setm.answer[0].answer }}</p> -->
          </div>
          </Col>
          <Col class="e-list-c" v-else-if="
            questions.question.question_type.basic_ques_types == '8,9'
          "><!-- 混合题 -->
          <p class="e-list-c-b" v-if="questions.question.formatData.stem_src_txt"
            v-html="questions.question.formatData.stem_src_txt"></p>
          <div v-show="questions.question.formatData.sub_headings"
            v-for="(setm, i) in questions.question.formatData.sub_headings" :key="i">
            <div class="e-list-c-c dis" v-html="i + 1 + '.' + setm.sub_heading"></div>
            <div class="e-list-c-a" v-if="setm.options">
              <RadioGroup v-model="questions.question.ques_sub_headings[i].answe" vertical>
                <Radio :label="option.option_k" v-for="(option, i) in setm.options" :key="i" :id="option.option_k">
                  <span v-html="String.fromCharCode(65 + i) + '.' + option.option
                    "></span>
                </Radio>
              </RadioGroup>
            </div>
          </div>
          </Col>
        </Row>
        <Row>
          <div class="answer">
            <div v-show="rightAnswer.length > 0" class="item" v-for="(i, n) in rightAnswer" :key="n">
              {{ n + 1 }}.
              <span :style="{
                color: i.is_right == 2 ? '#01a724' : '#f00',
              }">{{
                i.is_right == 2 ? "回答正确" : "回答错误："
              }}</span>
              <div v-show="i.is_right == 1" v-if="type == 2 || type == 11">正确答案为：
                <p style="color: #01a724" v-html="i.answer"></p>
                你的答案为：<p style="color: #f00">{{
                  filterAnswer(i.s_answer)
                }}</p>
              </div>
              <span v-show="i.is_right == 1" v-else>正确答案为：
                <span style="color: #01a724">{{
                  filterAnswer(i.answer)
                }}</span>
                你的答案为：<span style="color: #f00">{{
                  filterAnswer(i.s_answer)
                }}</span>
              </span>
              <p style="color:#999">【解析】{{ i.analysis }}</p>
              <p style="color:#999">【考点】{{ questions.knowledge || '-' }}</p>
            </div>
          </div>
        </Row>
        <Row v-if="questions.question && questions.question.length == 0">
          <div style="width: 100%; text-align: center; font-size: 20px">
            暂无数据
          </div>
        </Row>
        <Row style="width: 100%; margin-top: 10px" v-if="questions.question && questions.question.length != 0">
          <Col :span="16"><Button @click="saveques(questions.questype_id, questions.question)">提交</Button>
          <Button @click="prex(questions.id, questions.questype_id)" :disabled="preDisabled">上一题</Button><Button
            @click="next(questions.id, questions.questype_id)" :disabled="nextDisabled">下一题</Button></Col>
        </Row>
      </div>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: 0,
      showin: "b",
      qesid: "",
      questionsObj: {},
      questiontypeArr: [],
      preDisabled: true, //上禁用按钮
      nextDisabled: false, //下禁用按钮
      questions: {},
      rightAnswer: [],
    };
  },
  activated() {
    this.getquestion_type(this.$route.query.id);
    // setTimeout(() => {
    //   console.log(this.type, this.batch);
    // }, 3000);
  },
  computed: {
    type() {
      if (this.questions.question.question_type)
        return this.questions.question.question_type.basic_ques_types;
      else return "";
    },
    batch() {
      if (this.questions.question.question_type)
        return this.questions.question.question_type.batch;
      else return "";
    },
    filterAnswer() {
      return function (answer) {
        switch (this.type) {
          case "3":
          case "5":
          case "10":
            let space_str = "\u0000";
            return String.fromCharCode(parseInt(answer) + 65).replace(
              space_str,
              ""
            );
            break;
          default:
            return answer;
            break;
        }
      };
    },
  },
  methods: {
    changMenuItem(e) {
      this.showin = e;
    },
    // 渲染后台回传为混合问题答案的回显
    render() {
      if (this.type == "8,9") {
        // 输入框和单选按钮都是后台返回，所以此处无法双向绑定，暂时通过dom操作回显
        // 1 获取渲染时index值
        let [arr, newArr] = [
          this.questions.question.formatData.sub_headings,
          [],
        ];
        arr.forEach((res, index) => {
          // console.log(res, this.rightAnswer);
          if (res.options.length != 0) {
            newArr.push(index);
            // newArr.push({ a: res });
            // } else {
            // newArr.push({ b: res });
          }
        });
        // console.log(newArr, this.rightAnswer);
        // 2 遍历回显数据将为index的转译
        newArr.forEach((index) => {
          let answer = this.rightAnswer[index].answer;
          let s_answer = this.rightAnswer[index].s_answer;

          let space_str = "\u0000";
          this.rightAnswer[index].answer = String.fromCharCode(
            parseInt(answer) + 65
          ).replace(space_str, "");

          this.rightAnswer[index].s_answer = String.fromCharCode(
            parseInt(s_answer) + 65
          ).replace(space_str, "");
        });
      }
    },
    // 正则替换
    regReplcae(str) {
      let reg = /(\_)\1+/g;
      return str.replace(reg, "<input />");
    },
    set_input_2(stem) {
      let arr = stem.split("<Input/>");
      let newArr = "";
      arr.map(function (item, index) {
        if (index < arr.length - 1) {
          newArr += item + `<Input disabled />`
        } else {
          newArr += item;
        }
      });
      return newArr;
    },
    // 获取题型
    getquestion_type(id) {
      this.questiontypeArr = [];
      this.$axios
        .post("/app/correlation_question_type_storage/getlist", {
          storage_id: id,
        })
        .then((res) => {
          if (res.code == 1) {
            if (res.data) {
              this.questiontypeArr = res.data;
              this.getquestioncount(res.data[0], 0);
            }
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    next(id, quesid) {
      var that = this;
      that.preDisabled = false;
      that.getnextOrLast(id, quesid, 2);
    },
    prex(id, quesid) {
      var that = this;
      that.getnextOrLast(id, quesid, 1);
    },
    //统计数量
    getInputLenth(str, type) {
      return str.split(type).length - 1;
    },
    // 返回答案数组
    tranArr(obj) {
      let [arr, inputIndex, textAreaIndex] = [[], 0, 0];

      obj.forEach((el, a) => {
        if (el.sub_heading && el.sub_heading.indexOf("Input") != -1) {
          // 每个答案中，input的数量
          let num = this.getInputLenth(el.sub_heading, "Input");
          // let inputIndex = 0;
          // 当答案为输入  框时，数据格式为sub_heading时
          // 迭代指定Input输入框内容
          let doms = document.querySelectorAll(".e-list-c-c input");
          doms = doms.length
            ? doms
            : document.querySelectorAll(".e-list-c-x input");
          for (let i = 0; i < num; i++) {
            doms[inputIndex]
              ? arr.push(doms[inputIndex].value)
              : arr.push(null);
            inputIndex++;
          }
        } else if (this.type == 7 && el.stem) {
          let num = this.getInputLenth(el.stem, "Input");
          // console.log(num,2111)
          let doms = document.querySelectorAll("input");
          doms = doms.length
            ? doms
            : document.querySelectorAll(".e-list-c-x input");
          for (let i = 0; i < num; i++) {
            doms[inputIndex]
              ? arr.push(doms[inputIndex].value)
              : arr.push(null);
            inputIndex++;
          }
          // console.log(num,doms,inputIndex,21111111)
        }
        // 这里判断出来的结果也是选择题，逻辑上有问题 ，直接走最后的else
        else if (el.sub_heading && el.sub_heading.indexOf("_") != -1 && !(this.type == 8, 9)) {
          console.log(111111111)
          // 下划线类型
          let doms = document.querySelectorAll(".e-list-c-c input");
          // console.log(doms)
          doms[inputIndex] ? arr.push(doms[inputIndex].value) : arr.push(null);
          inputIndex++;
        }
        else if ((!el.stem || el.stem == "") && !(this.type == 10 || this.type == 8, 9 || this.type == 5 || this.type == 4)) {
          // 当答案为输入框时, 数据格式为stem时
          // 依次添加
          console.log(233333333333332)
          let doms = document.querySelectorAll(".e-list-c input");
          doms = doms.length
            ? doms
            : document.querySelectorAll(".e-list-c-x input");
          doms.forEach((eln) => {
            arr.push(eln.value);
          });
          // } else if (this.type == 11) {
          //   // 当类型为写作, 答案为文本域时
          //   // 迭代指定textArea文本框内容
          //   console.log(el,222222)
          //   let doms = document.querySelectorAll(".e-list-c-c textarea");
          //   arr.push(doms[textAreaIndex].value);
          //   textAreaIndex++;
        } else if (this.type == 12) {
          arr = el.answe
        } else {
          console.log(el.answe, 1111)
          el.answe ? arr.push(el.answe) : arr.push(null);
        }
      });
      return arr;
    },
    // 过滤参数
    filterSaveParams(questions) {
      let [obj, sub, stem, arr] = [
        { ques_id: questions.id },
        questions.ques_sub_headings,
        questions.ques_stem,
        [],
      ];
      console.log(questions.ques_stem)
      // console.log(sub);
      // 批量
      if (this.batch == 1) {
        switch (this.type) {
          case "3":
          case "5":
          case "6":
          case "8,9":
          case "10":
            if (sub) arr = this.tranArr(sub);
            break;
          default:
            if (sub.length > 0) arr = this.tranArr(sub);
            if (stem.length > 0) arr = this.tranArr(stem);
            break;
        }
      }
      // 非批量
      if (this.batch == 2) {
        console.log('sub', sub)
        switch (this.type) {
          case "3":
          case "4":
          case "5":
            if (sub) arr = this.tranArr(sub);
            break;
          case "2":
            // if (sub.length > 0) arr = this.tranArr(sub);
            if (stem.length > 0) arr = this.tranArr(stem);
            break;
          case "7":
          case "11":
            if (stem) arr = this.tranArr(stem);
            break;
          default:
            if (sub.length > 0) arr = this.tranArr(sub);
            if (stem.length > 0) arr = this.tranArr(stem);
            break;
        }
      }
      obj.answer = arr;
      return { answer: JSON.stringify(obj) };
    },
    saveques(questype_id, questions) {
      this.$axios
        .post(
          "/app/examination_questions/submitQues",
          this.filterSaveParams(questions)
        )
        .then((res) => {
          if (res.code == 1) {
            this.getquestionsObj(questype_id);
            // this.$Message.success("答案已保存");
            this.rightAnswer = res.data;
            // 渲染答案
            this.render();
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    getnextOrLast(id, quesid, num) {
      var that = this;
      var date = {};
      date.storage_id = that.$route.query.id;
      date.ques_type_id = quesid;
      date.question_id = id;
      date.type = num;
      that.$axios
        .get("/app/examination_questions/nextOrLast", date)
        .then((res) => {
          if (res.code == 1) {
            that.questions = {};
            this.rightAnswer = [];
            that.qesid = res.data.id;
            if (num == 2 && res.data.is_none == 1)
              (that.nextDisabled = true), (that.preDisabled = false);
            if (num == 1 && res.data.is_none == 1)
              (that.preDisabled = true), (that.nextDisabled = false);
            that.questions = res.data;
            that.$forceUpdate();
          } else {
            that.$Message.error(res.msg);
          }
        });
    },
    getquestion(id) {
      this.rightAnswer = [];
      this.questions = {};
      this.$axios
        .get("/app/examination_questions/getCurrentQuestionId", {
          storage_id: this.$route.query.id,
          ques_type_id: id,
        })
        .then((res) => {
          if (res.code == 1) {
            this.questions = res.data;
            this.qesid = res.data.id;
            this.preDisabled = res.data.is_last == 0 ? true : false;
            this.nextDisabled = res.data.is_next == 0 ? true : false;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    getquestioncount(row, index) {
      if (this.show == index && index > 0) {
        return false;
      }
      this.getquestion(row.question_type.id);
      this.show = index;
      this.getquestionsObj(row.question_type.id);
    },
    getquestionsObj(id) {
      this.questionsObj = {};
      this.$axios
        .post("/app/examination_questions/getData", {
          storage_id: this.$route.query.id,
          ques_type_id: id,
        })
        .then((res) => {
          if (res.code == 1) {
            this.questionsObj = res.data;
            if (this.questionsObj.total_count == 0) {
              this.preDisabled = true;
              this.nextDisabled = true;
            } else if (this.questionsObj.finish_count == 0) {
              this.preDisabled = true;
              this.nextDisabled = false;
            } else {
              this.preDisabled = false;
              this.nextDisabled = false;
            }
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
.menu {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #d1d1d1;

  div {
    text-align: center;
    margin: 0 24px;
    width: 60px;
    height: 50px;
    line-height: 50px;
    cursor: pointer;

    a {
      color: #515a6e;
    }
  }

  .actived {
    color: #2d8cf0;
    height: 100%;
    border-bottom: 2px solid #2d8cf0;
  }
}

.group-name:nth-child(n + 2)::before {
  content: " / ";
}

.item {
  padding-left: 20px;
}

.questionbank {
  width: 100%;
  padding: 6px 2%;

  .questionbank-left {
    border: 1px solid #eee;

    .left-p {
      color: #000;
      font-size: 20px;
      font-weight: 600;
      border-bottom: 1px solid #eee;
      padding: 10px 10px 0;
      height: 50px;
    }

    .left-div {
      height: 75vh;
      overflow: auto;
      line-height: 1.6;
      font-size: 15px;

      a {
        display: block;
        padding: 10px;
        margin: 0;
      }
    }
  }

  .questionbank-right {
    border: 1px solid #eee;
    border-left: 0;
    overflow: auto;
    height: 80vh;

    .right-p {
      height: 50px;
      padding: 20px 10px 0;
      font-size: 17px;
      border-bottom: 1px solid #eee;
    }

    .right-div {
      .right-div-p {
        padding: 10px 10px 0;
        color: #73bbdd;
        font-size: 15px;
      }

      .e-list {
        //
        font-size: 17px;
        line-height: 1.8;
        //
        display: block;
        background: #fff;
        margin-top: 10px;
        padding: 10px;
        min-height: 55vh;
        overflow: auto;

        .e-list-c-b {
          border-bottom: 1px solid #eee;
          //font-size: 13px;
          font-size: 16px;

          // text-overflow: -o-ellipsis-lastline;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 2;
          // line-clamp: 2;
          // -webkit-box-orient: vertical;
          color: #555;
          font-weight: 600;
          line-height: 1.8;
        }

        .dis {
          display: flex;
        }

        .e-list-c-a {
          /deep/ p {
            align-items: center;
            display: flex;
            margin-left: 4px;
          }

          /deep/ .ivu-radio-group-vertical .ivu-radio-wrapper {
            height: auto;
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            span {
              align-items: center;
              display: flex;
            }
          }
        }

        .e-list-c-c {
          line-height: 1.8;

          /deep/ p {
            align-items: center;
            display: inline-block;
          }
        }
      }
    }
  }

  .daan {
    display: flex;
    align-items: center;
    margin-top: 10px;

    p {
      max-width: 60px !important;
      width: 50px !important;
    }
  }

  /deep/ input {
    width: 150px;
    max-width: 300px;
    border: 0;
    border-radius: 0;
    margin-top: -10px;
    text-align: center;
    border-bottom: 1px solid #999;
    background: #fff
  }
}

/deep/.duoxuan {
  .ivu-checkbox-group-item {
    margin: 10px;
    display: flex;
  }

  .text {
    display: flex;
    margin-left: 10px;
  }
}
</style>
